import { httpRequest } from '@/services/httpClient'

export type Organization = {
  organizationId: number
  tenantId?: number
  name: string
  code?: string | null
  description?: string | null
  organizationType?: string | null
  parentId?: number | null
  isActive: boolean
  isDeleted: boolean
  deletedAt?: string | null
  createdAt: string
  lastUpdated: string
}

export type OrganizationsListResponse = {
  items: Organization[]
  totalCount: number
  page: number
  pageSize: number
}

export type OrganizationsListParams = {
  tenantId?: number
  search?: string
  isActive?: boolean | null
  includeDeleted?: boolean
  organizationType?: string | null
  page?: number
  pageSize?: number
  sortBy?: 'code' | 'name' | 'lastUpdated'
  sortDir?: 'asc' | 'desc'
}

export type CreateOrganizationPayload = {
  tenantId?: number
  code: string
  name: string
  description?: string | null
  isActive?: boolean
  organizationType?: string | null
  parentId?: number | null
}

export type UpdateOrganizationPayload = CreateOrganizationPayload & {
  id: number
}

export type CreateUpdateResponse = {
  success: boolean
  data?: {
    id: number
    name: string
    code?: string | null
  }
  message?: string
}

export const organizationsApi = {
  list: (params: OrganizationsListParams) =>
    httpRequest<OrganizationsListResponse>('/v1/organizations', {
      method: 'GET',
      query: {
        tenantId: params.tenantId,
        search: params.search?.trim() ? params.search.trim() : undefined,
        isActive: params.isActive === null ? undefined : params.isActive,
        includeDeleted: params.includeDeleted,
        organizationType: params.organizationType ?? undefined,
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 10,
        sortBy: params.sortBy,
        sortDir: params.sortDir,
      },
    }),

  getById: (id: number) => httpRequest<Organization>(`/v1/organizations/${id}`, { method: 'GET' }),

  create: (payload: CreateOrganizationPayload) =>
    httpRequest<CreateUpdateResponse>('/v1/organizations', {
      method: 'POST',
      body: payload,
    }),

  update: (payload: UpdateOrganizationPayload) =>
    httpRequest<CreateUpdateResponse>(`/v1/organizations/${payload.id}`, {
      method: 'PUT',
      body: payload,
    }),

  delete: (id: number) =>
    httpRequest<{ success: boolean; message?: string }>(`/v1/organizations/${id}`, {
      method: 'DELETE',
    }),
}

